// extracted by css-extract-rspack-plugin
export default {"fileView":"fileView-NXhszA"};